import React, { useEffect, useState } from 'react';
import useChunkedRideData from './useChunkedRideData';
import { Avatar, Box, Grid2, Typography } from '@mui/material';
import CarDriver from '../assets/images/CabDriver.svg';
import successIcon from '../assets/images/Sucessicon.svg';
import vehicleTypeCar from '../assets/images/vehicleTypeCar.svg';
import vehicletypeAuto from '../assets/images/vehicletypeAuto.svg';
import vehicleTypeBike from '../assets/images/vehicleTypeBike.svg';
import altAvatar from '../assets/images/altAvatar.svg';
import {makePostRequestToUrl} from './commonFunc.jsx';
import config from '../config/config.js';

const RideRequestComponent = (props) => {
  const operationsUrl = config.operationsUrl;
  const [message, setMessage] = useState('');
  const [snackbar, showSnackbar] = useState(false);

  const [showOneFlagModal, setShowOneFlagModal] = useState(false);

  const autoAssignParams = props.autoAssignParams;

  console.log(autoAssignParams,"autosadkjhfa");

  const setFullScreenLoader = props.setFullScreenLoader;
  const setAutoCancel = props.setAutoCancel;
  const userByPhoneId = props.userByPhone;

  const normalAssign = props.normalAssign;

  const params = {
    user_id: autoAssignParams.user_id,
    vehicle_id: autoAssignParams.vehicle_id,
    pickup_latitude: String(autoAssignParams.pickup_latitude),
    pickup_longitude: String(autoAssignParams.pickup_longitude),
    pickup_address: autoAssignParams.pickup_address,
    drop_latitude: String(autoAssignParams.drop_latitude),
    drop_longitude: String(autoAssignParams.drop_longitude),
    drop_address: autoAssignParams.drop_address,
    ride_distance: autoAssignParams.ride_distance,
    ride_eta: autoAssignParams.ride_eta,
    estimated_fare: autoAssignParams.estimated_fare,
    waypoints: autoAssignParams.waypoints,
    is_panel_request: 1,
    admin_id:autoAssignParams.admin_id,
  };

  if(normalAssign){
    params['driver_array'] = autoAssignParams.driver_array;
  }
  if (autoAssignParams.fare_obj) {
    params.fare_obj = autoAssignParams.fare_obj;
}
if (autoAssignParams.corporate_id) {
    params.corporate_id = autoAssignParams.corporate_id;
}
if (autoAssignParams.payment_mode) {
    params.payment_mode = autoAssignParams.payment_mode;
}

const PARCEL_KEYS = [
    'is_parcel', 'merchant_id', 'stop_parcel_details',
    'sender_name', 'sender_mobile', 'sender_flat_house_no', 'sender_instructions',
    'recipient_name', 'recipient_mobile', 'recipient_flat_house_no',
    'weight_unit', 'weight', 'size_unit', 'length', 'height',
];

PARCEL_KEYS.forEach((k) => {
    if (autoAssignParams[k] !== undefined) params[k] = autoAssignParams[k];
});

  const { chunkedNoDriversFound, loading, chunkedAutoAssigned, engagementData, initialRequestId, chunkedOne, chunkedOneMessage } = useChunkedRideData(params);

  const [showModal, setShowModal] = useState(false);
  const [showAutoAssignedModal, setShowAutoAssignedModal] = useState(false);

  React.useEffect(() => {
    if (chunkedNoDriversFound) {
      setShowModal(true);
    //   setFullScreenLoader(false);
    }
  }, [chunkedNoDriversFound]);

  React.useEffect(() => {
    if (chunkedOne) {
      setShowOneFlagModal(true);
    //   setFullScreenLoader(false);
    }
  }, [chunkedOne]);

  const handleCloseModal = () => {
    setShowModal(false);
    setShowAutoAssignedModal(false);
    setFullScreenLoader(false);
    window.location.reload();
  };

  const handleCloseOneFlagModal = () => {
    setShowOneFlagModal(false);
    setFullScreenLoader(false);
    window.location.reload();
  };

  React.useEffect(() => {
    if (chunkedAutoAssigned) {
        setShowAutoAssignedModal(true);
        // setFullScreenLoader(false);
    }
  }, [chunkedAutoAssigned]);

//   useEffect(() => {
//     if (initialRequestId) {
//         handleCancelAutoAssignModal();
//     }
//   }, [initialRequestId]);

    const handleCancelAutoAssignModal = async() => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            trip_request_id: initialRequestId,
            user_id: userByPhoneId, 
        };
        try {
            const url = operationsUrl + '/panel/cancel_ride';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
        setFullScreenLoader(false);
        setAutoCancel(false);
    }

  return (
    <div>

        {!loading && showModal && (
            <Box
                sx={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",alignItems: "center", zIndex: 1300,
                    backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center"
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px", alignItems: "center",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center", display: "flex", flexDirection: "column", 
                    }}
                >
                    <img src={CarDriver} alt="No drivers found"/>

                    <Typography sx={{ fontSize: "24px", color: "#000", marginBottom: "14px" }}>
                        <span style={{color:'#D14545'}}>Ooops!</span> No Driver Found
                    </Typography>

                    <Typography sx={{ fontSize: "16px", color: "#83888E", marginBottom: "24px" }}>
                        No driver found or driver didn't accept ride.
                    </Typography>

                    <Typography
                        onClick={handleCloseModal}
                        sx={{
                            cursor: "pointer",color: "#0065FF",fontWeight: "500",fontSize: "14px",textDecoration: "none",
                            "&:hover": {textDecoration: "underline"}
                        }}
                    >
                        Try Again Later
                    </Typography>

                    {/* <Grid2 sx={{display:'flex'}}>
                        <Typography
                            // onClick={() => setNoDriverFound(false)}
                            sx={{
                                cursor: "pointer", backgroundColor:'#F9F9F9',
                                color: "#0065FF", border:'1px solid #D1D5DB',
                                fontWeight: "500", padding:'8px', borderRadius:'8px',
                                fontSize: "14px", color:'#4E545D',
                                textDecoration: "none", width:'140px', marginRight:'4%',
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }}
                        >
                            Try Another Method
                        </Typography>

                        <Typography
                            // onClick={}
                            sx={{
                                cursor: "pointer", backgroundColor:'#F9F9F9',
                                color: "#0065FF", border:'1px solid #0065FF',
                                fontWeight: "500", padding:'8px', borderRadius:'8px',
                                fontSize: "14px",
                                textDecoration: "none", width:'140px',
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }}
                        >
                            Try Again
                        </Typography>
                    </Grid2> */}
                    
                </Box>
            </Box>
        )}

        {showAutoAssignedModal && !loading && engagementData && (
            <Box
                sx={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center",
                    alignItems: "center", zIndex: 1300,
                }}
            >
                {/* Centered Modal Box */}
                <Box
                    sx={{
                        backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center",
                        display: "flex", flexDirection: "column", alignItems: "center",
                    }}
                >
                    {/* Title */}
                    <img src={successIcon} alt="green check"/>

                    {/* Subtext */}
                    <Typography sx={{ fontSize: "24px", color: "#000", marginBottom: "14px" }}>
                        Ride Assigned.
                    </Typography>

                    <Typography sx={{ fontSize: "16px", color: "#83888E", marginBottom: "24px" }}>
                        Ride successfully assigned to the selected driver.
                    </Typography>

                    <Grid2 sx={{border:'1px solid #D1D5DB', padding:'8px', margin:'4px', borderRadius:'12px'}}>
                        <Grid2 sx={{backgroundColor:'#1A1E25', padding:'8px 16px', borderRadius:'8px', width:'340px', height:'40px'}}>
                            <span style={{color:'#83888E', fontSize:'14px'}}>Booking ID : </span>
                            <span style={{color:'#fff', fontSize:'16px'}}>{engagementData.engagement_id}</span>
                        </Grid2>

                        <Grid2 item container sx={{padding:'8px'}}>
                            <Grid2 item size={2}>
                                {engagementData.driver_image && (
                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={'driver'} src={engagementData.driver_image}></Avatar>
                                )}
                                {!engagementData.driver_image && (
                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={'driver'} src={altAvatar}></Avatar>
                                )}
                            </Grid2>
                            <Grid2 item size={5.7}>
                                <Grid2 item sx={{alignItems:'left'}}>
                                    <Typography sx={{color:'#83888E', fontSize:'14px', textAlign:'left'}}>{engagementData.driver_name}</Typography>
                                    <Typography sx={{color:'#1A1E25', fontSize:'16px', textAlign:'left'}}>ID: {engagementData.driver_id}</Typography>
                                </Grid2>
                            </Grid2>
                            <Grid2 item size={2} sx={{marginTop:'4%'}}>
                                <Typography sx={{color:'#0065FF', fontSize:'16px'}}>{engagementData.driver_phone_number}</Typography>
                            </Grid2>
                        </Grid2>

                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />

                        <Grid2 item container>
                            <Grid2 item size={2}>
                                {engagementData.vehicle_type==1 && (
                                    <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                )}
                                {engagementData.vehicle_type==2 && (
                                    <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                )}
                                {engagementData.vehicle_type==3 && (
                                    <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                )}
                            </Grid2>
                            <Grid2 item size={6}>
                                <Grid2 item>
                                    <Typography sx={{color:'#83888E', fontSize:'10px', textAlign:'left'}}>{engagementData.vehicle_name}</Typography>
                                    <Typography sx={{color:'#4E545D', fontSize:'12px', textAlign:'left', fontWeight:'400'}}>{engagementData.vehicle_no}</Typography>
                                </Grid2>
                            </Grid2>
                            {/* <Grid2 item size={2} sx={{marginTop:'4%'}}>
                                <Typography sx={{color:'#0065FF', fontSize:'16px'}}>62020202</Typography>
                            </Grid2> */}
                        </Grid2>

                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />

                        <Grid2 item container>
                            <Grid2 item size={3}>
                                <Typography sx={{color:'#83888E', fontSize:'12px'}}>Payment Type</Typography>
                                <Typography sx={{color:'#1A1E25', fontSize:'16px'}}>{engagementData.payment_mode == 1 ? 'CASH' : 'STRIPE'}</Typography>
                            </Grid2>

                            <Grid2 item size={3}>
                                <Typography sx={{color:'#83888E', fontSize:'12px'}}>Fare</Typography>
                                <Typography sx={{color:'#1A1E25', fontSize:'16px'}}>{engagementData.estimated_fare}</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Typography
                        onClick={handleCloseModal}
                        sx={{
                            cursor: "pointer",
                            color: "#0065FF", // Blue text color
                            fontWeight: "500", // Slightly bold text
                            fontSize: "14px",
                            textDecoration: "none", marginTop:'12px',
                            "&:hover": {
                                textDecoration: "underline", // Add underline on hover
                            },
                        }}
                    >
                        Got It
                    </Typography>
                    
                </Box>
            </Box>
        )}

        {showOneFlagModal && (
            <Box
                sx={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center",
                    alignItems: "center", zIndex: 1300,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center", display: "flex", flexDirection: "column", 
                    }}
                >
                    <img src={CarDriver} height="210px" width="210px" alt="No drivers found" style={{alignSelf:'center'}}/>

                    <Typography sx={{ fontSize: "20px", color: "#000", marginBottom: "14px" }}>
                        {chunkedOneMessage}
                    </Typography>

                    <Typography
                        onClick={handleCloseOneFlagModal}
                        sx={{
                            cursor: "pointer",color: "#0065FF",fontWeight: "500",fontSize: "18px",textDecoration: "none",
                            "&:hover": {textDecoration: "underline"},
                        }}
                    >
                        OK
                    </Typography>
                </Box>
            </Box>
        )}
    </div>
  );
};

export default RideRequestComponent;